import { LanguagePicker } from '@dealstack/frontend/shared/components/LanguagePicker/LanguagePicker';
import {
	TEST_ELEMENT_IDS,
	UIElementIdentifier,
} from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import React, { memo, Suspense } from 'react';
import { Link } from 'react-router-dom';
import { BreadcrumbsV2 } from '@dealstack/frontend/shared/components/Breadcrumbs/BreadcrumbsV2';
import { UserDropdown } from '@dealstack/frontend/shared/components/UserDropdownV2/UserDropdown';
import {
	ContactDetailsWrapper,
	HeaderContainer,
	HeaderLogo,
	LeftPart,
	RightPart,
} from '@dealstack/frontend/shared/components/Header/Header.styles.ts';
import { HelpBlogButton } from '@dealstack/frontend/shared/components/HelpBlogButton/HelpBlogButton.tsx';
import { ApplicationType } from '@dealstack/shared/lib/generated';

interface Props {
	defaultProtectedRoute: string;
	isInvestorApp?: boolean;
	investmentsDropdown?: React.ReactNode;
}

const Header = ({ isInvestorApp, defaultProtectedRoute, investmentsDropdown }: Props) => {
	return (
		<HeaderContainer>
			<LeftPart gap="1rem">
				<Link to={defaultProtectedRoute} style={{ display: 'flex' }}>
					<HeaderLogo size="sm" variant="dealstack-logo-black" />
				</Link>
				<BreadcrumbsV2 />
				{investmentsDropdown}
			</LeftPart>
			<RightPart gap="0.5rem">
				<ContactDetailsWrapper gap="0.5rem">
					<Suspense fallback={null}>
						<HelpBlogButton
							dataset={
								isInvestorApp ? ApplicationType.INVESTOR : ApplicationType.DEALSTACK
							}
						/>
					</Suspense>
				</ContactDetailsWrapper>

				<UIElementIdentifier identifier={TEST_ELEMENT_IDS.MAIN_LAYOUT_USER_DROPDOWN}>
					<UserDropdown />
				</UIElementIdentifier>
				{isInvestorApp && <LanguagePicker />}
			</RightPart>
		</HeaderContainer>
	);
};
const _HeaderExport = memo(Header);

export { _HeaderExport as Header };
